<template>
    <div class="login_box">


        <div class="box2">
            <h5>点点购后台管理系统</h5>
            <table border="1" class="table_box " bordercolor="#ccc">
                <tr>
                    <td width="100" height="35">账号:</td>
                    <td><input v-model="tableData[0].username" style="height:22px;"></td>
                </tr>
                <tr>
                    <td width="100" height="35">密码:</td>
                    <td><input v-model="tableData[0].pwd" type="password" style="height:22px;"></td>
                </tr>
                <tr>
                    <td width="100" height="35"></td>
                    <td>
                        <el-button class="btn" size="mini" @click="submitFrom">登录</el-button>
                    </td>
                </tr>
            </table>


        </div>
    </div>
</template>

<script>
    import {
        login
    } from '../api/api'
    import local from '../utils/local'

    export default {
        data() {
            return {
                tableData: [{
                    username: '',
                    pwd: ""
                }],

            };
        },
        methods: {
            submitFrom() {
                if (this.tableData[0].username == '' || this.tableData[0].pwd == '') {
                    this.$message.error('账号或密码不能为空');

                } else {
                    login(this.tableData[0].username, this.tableData[0].pwd).then(res => {
                        console.log(res)
                        if (res.data.status == 200) {
                            local.save("admin_id", res.data.data.admin_id);
                            this.$message({
                                type: 'success',
                                message: "登录成功"
                            });
                            this.$router.push('/home')
                        } else {
                            this.$message.error(res.data.msg);
                            // this.$message.error(res.data.data.msg)
                        }
                    })
                }


            }
        }
    };
</script>

<style lang="less" scoped>
    .box2 {
        width: 500px;
        // background-color: coral;
        margin: 0 auto;
        margin-top: 120px;
        text-align: center;

        h5 {
            font-size: 36px;
            margin-bottom: 20px;
            font-weight: normal;
            color: #333;
        }

        .table_box {
            width: 100%;
            border-collapse: collapse;
            text-align: left;
            border-color: #ccc;
            color: #333;
            font-size: 14px;
            font-weight: bold;

            .btn {
                color: #fff;
                background-color: #428bca;
                border-color: #357ebd;
            }
        }
    }
</style>